import type { UseDocumentProps } from '@ztechapps/common.hook'
import { subTaskQuery } from './graphql'
import { useTaskDocument } from './useTaskDocument'

export const useTaskWithSubTaskDocument = ({ query, _id, ...props } = {} as Partial<UseDocumentProps>) => {
  const defaultQuery = query ?? subTaskQuery

  return useTaskDocument({ query: defaultQuery, _id, ...props })
}
